import { professionWorkflowA } from './workflowA.js'
import { professionWorkflowB } from './workflowB.js'

export const professionWorkflow = Object.freeze({
  ...professionWorkflowA,
  ...professionWorkflowB,
})

export function getProfessionWorkflow(id) {
  return professionWorkflow[id] || null
}
